import React from "react";

interface Props {
  big?: boolean;
  pathFill?: string;
}
export default function Icon(props: Props) {
  return (
    <svg
      width={props.big ? "74" : "48"}
      height={props.big ? "74" : "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.9062 18.866L24.5649 6.269C24.3261 6.09422 24.0377 6 23.7417 6C23.4456 6 23.1572 6.09422 22.9184 6.269L5.57711 18.866C5.33763 19.0399 5.15948 19.2851 5.06821 19.5665C4.97695 19.8478 4.97727 20.1508 5.06913 20.4319L11.6947 40.8146C11.7862 41.0954 11.9642 41.3401 12.2033 41.5137C12.4424 41.6873 12.7304 41.781 13.026 41.7812H34.4617C35.0704 41.7812 35.6047 41.392 35.793 40.8146L42.4186 20.4319C42.6025 19.8545 42.3967 19.2247 41.9062 18.866ZM38.0438 19.7364L33.7304 21.1361L24.9722 14.807V10.2406L38.0438 19.7364ZM21.7273 26.3062L17.8255 31.6555L15.4082 24.2548L21.7273 26.3062ZM16.6344 22.0721L22.5155 17.825V23.9836L16.6344 22.0721ZM23.7417 27.7058L27.8537 33.3439H19.6297L23.7417 27.7058ZM24.9722 17.825L30.849 22.0721L24.9722 23.9792V17.825ZM25.7561 26.3062L32.0751 24.2548L29.6578 31.6555L25.7561 26.3062ZM22.5155 10.2406V14.807L13.7529 21.1361L9.43949 19.7364L22.5155 10.2406ZM8.73445 22.0896L12.5224 23.3187L16.0432 34.0962L13.6872 37.3286L8.73445 22.0896ZM15.6447 38.807L17.8474 35.7889H29.6403L31.843 38.807H15.6447ZM33.7961 37.3286L31.4401 34.0962L34.9609 23.3187L38.7489 22.0896L33.7961 37.3286Z"
        fill="#262C34"
      />
    </svg>
  );
}
